/** @format */
import { AxiosRequestConfig } from 'axios';

import { MarketCode } from '@toucan/config/markets';

import { client } from '@toucan/services/request-client';

import {
    CalcServiceRequest,
    CalcServiceResponse,
} from '@toucan/client/global/calculation-service';

/**
 * Gets the correct totals for a transaction from the
 * calculation service
 *
 * @param request Information to send to calculation service
 */
export const getCalcServicePricing = async (
    request: CalcServiceRequest,
    market: MarketCode,
    abortController?: AbortController,
    checkoutId?: string,
    csrfToken?: string
): Promise<CalcServiceResponse> => {
    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
            'X-CSRF-Token': csrfToken ?? '',
        },
        signal: abortController?.signal,
    };

    const response = await client.post(
        // Calc service is not just used when a checkoutId is available so both
        // the checkout and non-checkout version of the endpoints have to be
        // supported here
        checkoutId
            ? `/checkout/${checkoutId}/calculate/`
            : '/calculation-service/v2/calculate/',
        request,
        config
    );

    return response.data;
};
